// Create a new file DocxViewer.jsx
import * as mammoth from "mammoth";
import React, { useEffect, useState } from "react";

const DocxViewer = ({ fileData }) => {
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (fileData) {
      const arrayBuffer = new Uint8Array(fileData).buffer;

      mammoth
        .convertToHtml({ arrayBuffer })
        .then((result) => {
          setContent(result.value);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error converting DOCX to HTML:", err);
          setError("Failed to convert document");
          setLoading(false);
        });
    }
  }, [fileData]);

  if (loading) return <div>Converting document...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div
      className="docx-content"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default DocxViewer;
